/* EG Collections — Card Specs Config (card-content-2) */

window.EG_COLLECTION_CARD_SPECS = {
  // default fallback if a product type has no rule
  default: {
    rows: [],
    pills: []
  },

  // product.type (from lite payload) -> spec rows
  // NOTE: we match case-insensitively in JS
types: {
  // -----------------
  // Mice
  // -----------------
  mice: {
    pills: [
      { tags: ["Polling Rate_"] }    
    ],
    rows: [
      { label: "Connectivity:", tags: ["wired/wireless"] },
      { label: "Shape:",        tags: ["shape"] },
      { label: "Size:",         tags: ["p-size"] },
      { label: "Weight:",       tags: ["p-weight"] }
    ]
  },

  // -----------------
  // Mousepads
  // -----------------
  mousepads: {
    pills: [
      { tags: ["surface type__"] }, // e.g. "Surface Type__Speed"
      { tags: ["firmness__"] }      // e.g. "Firmness__Soft"
    ],
    rows: [
      { label: "Size:",           tags: ["size"] },
      { label: "Surface:",        tags: ["surface material"] },
      { label: "Texture:",        tags: ["surface texture"] },
      { label: "Stitched Edges:", tags: ["stitched edges"] }
    ]
  },

  // -----------------
  // Arm Sleeves
  // -----------------
  "arm sleeves": {
    pills: [
      { tags: ["style_"] }
    ],
    rows: [
      { label: "Style:",          tags: ["style"] },
      { label: "Colour:",         tags: ["colour"] },
      { label: "Size:",           tags: ["size"] },
      { label: "Sleeve Length:",  tags: ["sleeve-length"] }
    ]
  },

  // -----------------
  // Keyboards
  // -----------------
  keyboards: {
       pills: [
      { tags: ["Key Switches_"] }
    ],
    rows: [
      { label: "Layout:",       tags: ["layout"] },
      { label: "Macros:",       tags: ["F-Macro Keys_"] },
      { label: "Rollover:",     tags: ["Key Rollover__"] },
      { label: "Keycaps:",      tags: ["keycaps"] }
    ]
  },

  // -----------------
  // Headsets
  // -----------------
  headsets: {
    pills: [
      { tags: ["Wired/Wireless_"] }
    ],
    rows: [
      { label: "Connectivity:", tags: ["wired/wireless"] },
      { label: "Mic Type:",     tags: ["mic type"] },
      { label: "Audio Type:",   tags: ["audio type"] },
      // Liquid excludes "F-Audio Connection" variants; we can’t do that cleanly with startsWith,
      // so choose a safer prefix that matches your real tag names (usually "audio connection").
      { label: "Conn Type:",    tags: ["audio connection"] }
    ]
  },

  // -----------------
  // Microphones
  // -----------------
  microphones: {
    rows: [
      { label: "Connectivity:",  tags: ["wired/wireless"] },
      { label: "Mic Type:",      tags: ["mic type"] },
      { label: "Freq. Response:", tags: ["mic frequency response"] },
      { label: "Conn Type:",     tags: ["audio connection"] }
    ]
  },

  // -----------------
  // Earphones
  // -----------------
  earphones: {
    rows: [
      { label: "Connectivity:", tags: ["wired/wireless"] },
      { label: "Mic Type:",     tags: ["mic type"] },
      { label: "Conn Type:",    tags: ["audio connection"] }
    ]
  },

  // -----------------
  // Mouse Feet
  // -----------------
  "mouse feet": {
    pills: [
      { tags: ["glide"] }
    ],
    rows: [
      { label: "Material:",      tags: ["material"] },
      { label: "Thickness:",     tags: ["thickness"] },
      { label: "Rounded Edges:", tags: ["rounded edges"] },
      { label: "In the Box:",    tags: ["box"] }
    ]
  },

  // -----------------
  // Grip Tape
  // -----------------
  "grip tape": {
    rows: [
      { label: "Material:",      tags: ["material"] },
      { label: "Thickness:",     tags: ["thickness"] },
      { label: "Flatten Edges:", tags: ["flatten edges"] },
      { label: "Colour:",        tags: ["colour"] }
    ]
  },

  // -----------------
  // Keycaps
  // -----------------
  keycaps: {
    pills: [
      { tags: ["material"] }
    ],
    rows: [
      { label: "Layout:",     tags: ["layout"] },
      { label: "No of Keys:", tags: ["Total Keys__"] },
      { label: "Legend:",     tags: ["legend"] },
      { label: "Backlit:",    tags: ["backlit"] }
    ]
  },

  // -----------------
  // Wrist Rests
  // -----------------
  "wrist rests": {
    pills: [
      { tags: ["layout"] }
    ],
    rows: [
      { label: "Colour:",     tags: ["colour"] },
      { label: "Layout:",     tags: ["layout"] },
      { label: "Base:",       tags: ["base"] },
      { label: "Weight:",     tags: ["P-Weight__"] }
    ]
  },

  // -----------------
  // Controllers
  // -----------------
  controllers: {
    pills: [
      { tags: ["Wired/Wireless_"] }
    ],
    rows: [
      { label: "Connectivity:",  tags: ["wired/wireless"] },
      { label: "Conn Type:",     tags: ["connection"] },
      { label: "D-pad:",         tags: ["circular d-pad"] },
      { label: "Compatibility:", tags: ["compatible with"] }
    ]
  }
}
};

// Card pill colours (used by the pre-hover pills on the card)
window.EG_COLLECTION_CARD_PILL_COLORS = {
  // product.type (case-insensitive)
  mousepads: {
    // pill key (case-insensitive)
    "surface type": {
      balanced: "#00000050",
      control: "#00000050",
      speed: "#00000050"
    },
    firmness: {
      soft: "#11111150",
      mid: "#11111150",
      "extra soft": "#11111150",
      hard: "#11111150"
    }
  }
};
